// GET /api/payout/confirm returns translated states and a payout row id.
// Only accept the generic id when the row also has its payout UID.
export function getHoldPayoutId(row) {
    const id = row?.payout_id ?? (
        typeof row?.payout_uid === 'string' && /^PAYOUT_.+/.test(row.payout_uid) ? row.id : null
    );
    return (typeof id === 'number' && Number.isSafeInteger(id) && id > 0)
        || (typeof id === 'string' && /^[1-9]\d*$/.test(id)) ? id : null;
}

export function canHoldConfirmed(row, { enabled, role, tab }) {
    if (!enabled || !['ADMIN', 'SUPER'].includes(role) || tab !== '익일' || !getHoldPayoutId(row)) return false;
    if (row.can_hold === false) return false;
    // Display eligibility only. The hold API must atomically validate raw P/N states.
    return row.status === '완료' && row.transfer_status === '송금 대기'
        && row.payout_type === '익일' && row.payout_method === '은행'
        && row.merchant_deposit_yn === '이체' && row.transfer_error === 'N'
        && row.transfer_at === null && row.completed_at === null;
}

export function validateHoldReason(value) {
    if (!value.trim()) return '보류 사유를 입력해주세요.';
    if (value.length > 500) return '보류 사유는 최대 500자까지 입력할 수 있습니다.';
    return '';
}
